/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AdministrationQuantity } from './AdministrationQuantity'
import { CodeStub } from './CodeStub'
import { Weekday } from './Weekday'

export class RegimenItem {
  constructor(json: JSON | any) {
    Object.assign(this as RegimenItem, json)
  }

  date?: number
  dayNumber?: number
  weekday?: Weekday
  dayPeriod?: CodeStub
  timeOfDay?: number
  administratedQuantity?: AdministrationQuantity
}
